<template>
  <button
    v-if="myPermissions[permission]"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot/>
  </button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AuthButton',
  inheritAttrs: false,
  props: {
    permission: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('permission', [
      'myPermissions'
    ])
  }
}
</script>
